import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import { useLocation } from "react-router-dom";


const Table9 = ({ SetKoosheshJesmainScore, koosheshJesmainScore, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const [data, setData] = useState([])
  const { setGreadingScore } = useContext(jobContext)

  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.koosheshJesmi;
    if (items) {
      const masouliat = items[Object.keys(items)[0]];
      const masouliatData = [
        { name: "سطح یک", score: 8, isSelected: masouliat.value == 0 },
        { name: "سطح دو", score: 16, isSelected: masouliat.value == 1 },
        { name: "سطح سه", score: 24, isSelected: masouliat.value == 2 },
        { name: "سطح چهار", score: 32, isSelected: masouliat.value == 3 },
        { name: "سطح پنج", score: 40, isSelected: masouliat.value == 4 },
      ]

      setData(masouliatData)

      const selectedItem = masouliatData.find((i) => i.isSelected)?.score
      SetKoosheshJesmainScore(selectedItem)
      setGreadingScore((prev) => ({ ...prev, "koosheshJesmi": selectedItem }))
    }
  }, [reload])


  return (
    <div>
      <Row type={1}>
        <Column>سطح 1</Column>
        <Column>سطح 2</Column>
        <Column>سطح 3</Column>
        <Column>سطح 4</Column>
        <Column>سطح 5</Column>
      </Row>
      <Row type={2}>
        <Column paddingY={30}>
          بالا و پایین رفتن و خم و
          راست شدن و یا راه رفتن
          و ایستادن
        </Column>
        <Column paddingY={30}>
          تمرکز قوای سمعی و
          بصری
        </Column>
        <Column paddingY={30}>
          نشستن مداوم جهت
          کار با ماشین
        </Column>
        <Column paddingY={30}>
          حرکات بدنی مستلزم
          صرف نیروی
          جسمانی
        </Column>
        <Column paddingY={30}>
          جابجا کردن با حمل و
          نقل اشیاء بدون وسیله یا با
          وسیله
        </Column>
      </Row>
      {/* <Row type={4}>
        <Column>2
          ساعت در روز</Column>
        <Column>4 ساعت در روز</Column>
        <Column>4 ساعت در روز</Column>
        <Column>2 ساعت در روز</Column>
        <Column>0 ساعت در روز</Column>
      </Row> */}
      <Row>
        <Column>امتیاز شغل </Column>
        <Column isActive={true} size={1}>
          {koosheshJesmainScore}
        </Column>
      </Row>
    </div>
  );
};

export default Table9;
